export const NICKNAME_STATUSES = {
    DEFAULT: 'default',
    PENDING: 'pending',
    REJECTED: 'rejected',
    APPROVED: 'approved',
    ASSIGNED: 'assigned',
};